import { useEffect } from 'react'
import { useLoaderData } from 'react-router'
import { Flex } from '@radix-ui/themes'
import { SubscriptionMypageLayout } from '~/components/subscription/mypage-layout'
import { createClient, JSONAPIResponse } from '@/api-client'
import { Subscriptions } from '@/api-client/Subscriptions'
import { Button } from '~/components/subscription/button'
import { styles } from './styles.css'
import instagram from './instagram.svg'

export const loader = () => {
  return fetchSubscriptions()
}

function fetchSubscriptions() {
  return createClient(Subscriptions).getSubscriptions()
}

export const SubscriptionSubscribed: React.FC = () => {
  const {
    data: { data: subscriptions },
  } = useLoaderData() as JSONAPIResponse<typeof fetchSubscriptions>

  useEffect(() => {
    const subscription = subscriptions[0]

    if (subscription && subscription.attributes.status === 'active') {
      if (window.fbq) {
        window.fbq('track', 'Subscribe', {
          value: 2700,
          currency: 'JPY',
        }, {
          eventID: `subscription_subscribed_${subscription.id}`,
        })
      }

      if (window.dataLayer) {
        const key = `subscribed-tracked-${subscription.id}`

        if (!window.localStorage.getItem(key)) {
          window.localStorage.setItem(key, '1')
          window.dataLayer.push({ event: 'subscribed' })
        }
      }
    }
  }, [])

  return (
    <SubscriptionMypageLayout>
      <Flex direction="column" align="center" justify="start" gap="40px" width="100%">
        <Flex direction="column" align="center" gap="24px" width="100%">
          <Flex direction="column" align="center" width="100%">
            <h1 className={styles.heading}>
              定期便のお申し込みが
              <wbr />
              完了しました
            </h1>
            <p className={styles.text}>季節のブーケをお楽しみに😍</p>
          </Flex>
          <Button as="a" href="/subscription/mypage" size="m" fluid className={styles.button}>
            マイページを見る
          </Button>
        </Flex>
        <Flex direction="column" align="center" gap="8px" width="100%" className={styles.card}>
          <Flex direction="column" align="center" width="100%">
            <p className={styles.introduction}>
              アプリのお花屋さん「FLOWER（フラワー）」の最新情報は公式Instagramで。平日ほぼ毎日ライブ配信中⚡️お花好きさんはぜひフォローをお願いします！
            </p>
          </Flex>
          <Button as="a" size="s" href="https://www.instagram.com/flowr_is/" target="_blank">
            <Flex direction="row" align="center" gap="2px">
              <img src={instagram} style={{ width: '16px', height: '16px' }} />
              公式Instagramへ
            </Flex>
          </Button>
        </Flex>
      </Flex>
    </SubscriptionMypageLayout>
  )
}
